
          import { defineNuxtPlugin, useRuntimeConfig } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              globalThis.__sentry_nuxt_base_path = useRuntimeConfig().app.baseURL;
              await import("/app/apps/cue-subclient/sentry.client.config.ts")
            }
          });